module.exports = __webpack_public_path__ + "static/media/item_2_10.a3c97ecf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/report/item_2_10.png
// module id = 117
// module chunks = 0